export const yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const sponsorOptions = [
    { label: 'Yes', value: 'sponsored' },
    { label: 'No', value: 'unsponsored' },
]

export const productTagOptions = [
    { label: 'Best Seller', value: 'Best Seller' },
    { label: 'All time Favorite', value: 'All Time Favorite' },
    { label: 'Recommended', value: 'Recommended' },
    { label: 'New Comer', value: 'New Comer' },
]

export const featureOptions = [
    { label: 'Machine', value: 'Machine' },
    { label: 'Grinder', value: 'Grinder' },
    // { label: 'Beans', value: 'beans' },
    { label: 'Other', value: 'other' },
]

export const taxTypeOptions = [
    { label: 'Including', value: 0 },
    { label: 'Exluding', value: 1 },
]

export const subTypeOptions = [
    { label: 'Product', value: 0 },
    { label: 'Addon', value: 1 },
]

export const couponTypeOptions = [
    { label: 'Percentage', value: 0 },
    { label: 'Fix', value: 1 },
    { label: 'Buy one get one', value: 2 },
]

export const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
]

export const productOptions = [
    { label: 'Product', value: false },
    { label: 'Addon', value: true },
]

export const companyTypeOptions = [
    { label: 'Coffee Shop Owner', value: 0 },
    { label: 'Roaster', value: 1 },
]

export const shiftTypeOptions = [
    { label: 'Day', value: 'Day' },
    { label: 'Night', value: 'Night' },
]

export const daysOptions = [
    { label: 'Monday', value: 'mon' },
    { label: 'Tuesday', value: 'tue' },
    { label: 'Wednesday', value: 'wed' },
    { label: 'Thursday', value: 'thu' },
    { label: 'Friday', value: 'fri' },
    { label: 'Saturday', value: 'sat' },
    { label: 'Sunday', value: 'sun' },
]

export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]

export const moduleList = [
    { key: 'company', name: 'companies' },
    { key: 'company image', name: 'companies-image' },
    { key: 'branch feature', name: 'features' },
    { key: 'branch feature image', name: 'features-image' },
    { key: 'branch service', name: 'services' },
    { key: 'branch service image', name: 'services-image' },
    { key: 'branch schedule', name: 'branch-timings' },
    { key: 'branch', name: 'all-branches' },
    { key: 'branch image', name: 'all-branches-image' },
    { key: 'user', name: 'users' },
    { key: 'group', name: 'roles' },
    { key: 'permission', name: 'assign-permissions' },
    { key: 'category', name: 'categories' },
    { key: 'product', name: 'all-products' },
    { key: 'product image', name: 'all-products-image' },
    { key: 'plan', name: 'stripe' },
    { key: 'product plan', name: 'subscription' },
    { key: 'branch holiday', name: 'holidays' },
]
